// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #111827;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* Background light blobs for premium ambient feel */
.login-background-overlay {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 70% 30%, rgba(59, 130, 246, 0.15), transparent 40%),
              radial-gradient(circle at 30% 70%, rgba(147, 51, 234, 0.12), transparent 40%);
  pointer-events: none;
  z-index: 1;
}

.login-card {
  width: 100%;
  max-width: 440px;
  padding: 24px 16px;
  background: rgba(255, 255, 255, 0.05) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
  z-index: 2;
  color: #fff !important;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-logo {
  display: block;
  margin: 0 auto 16px auto;
  height: 90px;
  object-fit: contain;
  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.5));
}

.login-title {
  color: #ffffff !important;
  margin-bottom: 4px !important;
  font-weight: 700 !important;
}

.login-subtitle {
  color: rgba(255, 255, 255, 0.5) !important;
  font-size: 14px;
}

/* Form Styles Override for Dark Mode */
.login-card .ant-form-item-label > label {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 14px;
  font-weight: 500;
}

.login-card .ant-input,
.login-card .ant-input-affix-wrapper {
  background-color: rgba(255, 255, 255, 0.04) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  transition: all 0.3s;
}

.login-card .ant-input-affix-wrapper-focused,
.login-card .ant-input-affix-wrapper:focus,
.login-card .ant-input-affix-wrapper:hover,
.login-card .ant-input:focus,
.login-card .ant-input:hover {
  background-color: rgba(255, 255, 255, 0.07) !important;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;
}

.login-card .ant-input input,
.login-card .ant-input-affix-wrapper input {
  background-color: transparent !important;
  background: transparent !important;
  color: #ffffff !important;
}

/* Chrome autofill background transparent fix */
.login-card input:-webkit-autofill,
.login-card input:-webkit-autofill:hover, 
.login-card input:-webkit-autofill:focus, 
.login-card input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #1e2638 inset !important;
  -webkit-text-fill-color: #ffffff !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.login-card .ant-input-prefix {
  color: rgba(255, 255, 255, 0.4) !important;
  margin-right: 8px;
}

.login-card .ant-input-password-icon {
  color: rgba(255, 255, 255, 0.4) !important;
}

.login-card .ant-select-selector {
  background-color: rgba(255, 255, 255, 0.04) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
}

.login-card .ant-select-arrow {
  color: rgba(255, 255, 255, 0.4) !important;
}

.login-card .ant-select-selection-item {
  color: #ffffff !important;
}

.login-card .ant-select:hover .ant-select-selector {
  border-color: #3b82f6 !important;
}

/* Error message area */
.login-error-msg {
  margin-bottom: 16px;
  background-color: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  padding: 8px 12px;
  border-radius: 6px;
  text-align: center;
}

/* Button Stylings */
.login-form-button {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  height: 44px !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
  transition: all 0.3s !important;
}

.login-form-button:hover,
.login-form-button:focus {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,gGAAgG;AAClG;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;2FACyF;EACzF,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,2BAA2B;EAC3B,mCAAmC;EACnC,sDAAsD;EACtD,8BAA8B;EAC9B,qDAAqD;EACrD,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sDAAsD;EACtD,qDAAqD;EACrD,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;;;;EAKE,sDAAsD;EACtD,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;;EAEE,wCAAwC;EACxC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;;;;EAIE,yDAAyD;EACzD,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sDAAsD;EACtD,qDAAqD;EACrD,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,wCAAwC;EACxC,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,wEAAwE;EACxE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,2BAA2B;EAC3B,yDAAyD;AAC3D","sourcesContent":[".login-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #111827;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n}\n\n/* Background light blobs for premium ambient feel */\n.login-background-overlay {\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle at 70% 30%, rgba(59, 130, 246, 0.15), transparent 40%),\n              radial-gradient(circle at 30% 70%, rgba(147, 51, 234, 0.12), transparent 40%);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 440px;\n  padding: 24px 16px;\n  background: rgba(255, 255, 255, 0.05) !important;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  border-radius: 16px !important;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;\n  z-index: 2;\n  color: #fff !important;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.login-logo {\n  display: block;\n  margin: 0 auto 16px auto;\n  height: 90px;\n  object-fit: contain;\n  filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.5));\n}\n\n.login-title {\n  color: #ffffff !important;\n  margin-bottom: 4px !important;\n  font-weight: 700 !important;\n}\n\n.login-subtitle {\n  color: rgba(255, 255, 255, 0.5) !important;\n  font-size: 14px;\n}\n\n/* Form Styles Override for Dark Mode */\n.login-card .ant-form-item-label > label {\n  color: rgba(255, 255, 255, 0.7) !important;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.login-card .ant-input,\n.login-card .ant-input-affix-wrapper {\n  background-color: rgba(255, 255, 255, 0.04) !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n  transition: all 0.3s;\n}\n\n.login-card .ant-input-affix-wrapper-focused,\n.login-card .ant-input-affix-wrapper:focus,\n.login-card .ant-input-affix-wrapper:hover,\n.login-card .ant-input:focus,\n.login-card .ant-input:hover {\n  background-color: rgba(255, 255, 255, 0.07) !important;\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;\n}\n\n.login-card .ant-input input,\n.login-card .ant-input-affix-wrapper input {\n  background-color: transparent !important;\n  background: transparent !important;\n  color: #ffffff !important;\n}\n\n/* Chrome autofill background transparent fix */\n.login-card input:-webkit-autofill,\n.login-card input:-webkit-autofill:hover, \n.login-card input:-webkit-autofill:focus, \n.login-card input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 1000px #1e2638 inset !important;\n  -webkit-text-fill-color: #ffffff !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.login-card .ant-input-prefix {\n  color: rgba(255, 255, 255, 0.4) !important;\n  margin-right: 8px;\n}\n\n.login-card .ant-input-password-icon {\n  color: rgba(255, 255, 255, 0.4) !important;\n}\n\n.login-card .ant-select-selector {\n  background-color: rgba(255, 255, 255, 0.04) !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n}\n\n.login-card .ant-select-arrow {\n  color: rgba(255, 255, 255, 0.4) !important;\n}\n\n.login-card .ant-select-selection-item {\n  color: #ffffff !important;\n}\n\n.login-card .ant-select:hover .ant-select-selector {\n  border-color: #3b82f6 !important;\n}\n\n/* Error message area */\n.login-error-msg {\n  margin-bottom: 16px;\n  background-color: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  padding: 8px 12px;\n  border-radius: 6px;\n  text-align: center;\n}\n\n/* Button Stylings */\n.login-form-button {\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%) !important;\n  border: none !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  height: 44px !important;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;\n  transition: all 0.3s !important;\n}\n\n.login-form-button:hover,\n.login-form-button:focus {\n  opacity: 0.9;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
